import { render, staticRenderFns } from "./newsfive.vue?vue&type=template&id=56ba402e&scoped=true"
var script = {}
import style0 from "./newsfive.vue?vue&type=style&index=0&id=56ba402e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba402e",
  null
  
)

export default component.exports